import { Injectable } from '@angular/core';
import { Subject, Observable }    from 'rxjs';

import { UserModel, initUserModel  } from '../../../../../core'

@Injectable()
export class UsersStateService {
  private updatingUser = new Subject<UserModel>();
  private hideDialog = new Subject<{}>();
  userUpdated:Observable<UserModel>;
  hidingAddEditDialog:Observable<{}>;
  constructor() {
    this.userUpdated = this.updatingUser.asObservable();
    this.hidingAddEditDialog = this.hideDialog.asObservable();
    
   }
   updateUserList(user: UserModel){
    this.updatingUser.next(user)
  }
  hideAddEditDialog(){
    this.hideDialog.next({});
  }

}
